export const BASEURL = 'https://hmsbackend-95h6.onrender.com'

//for localhost : 'http://localhost:4040'

// webservice host link :  'https://hmsbackend-95h6.onrender.com'